import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export enum SetupIntentStatus {
    canceled = 'canceled',
    processing = 'processing',
    requiresAction = 'requiresAction',
    requiresConfirmation = 'requiresConfirmation',
    requiresPaymentMethod = 'requiresPaymentMethod',
    succeeded = 'succeeded'
}

export enum SetupIntentUsage {
    offSession = 'offSession',
    onSession = 'onSession'
}

export type SetupIntent = {
    id: string
    clientSecret: string
    /**
     * Epoch SECONDS, as Stripe returns it (`created: Int` in the schema).
     *
     * ⚠️ NOT directly renderable. `formatTimestamp` passes its argument to
     * moment, which reads a bare number as MILLISECONDS — so rendering this
     * value raw dates every row to January 1970 (FNP-1106). Use
     * `createdAtMillis`, normalised once in useSetupIntents.
     */
    created: number
    customerId: string
    description: string
    lastSetupError: string
    paymentMethod: string
    paymentMethodTypes: string[]
    status: SetupIntentStatus
    usage: SetupIntentUsage
    /**
     * `created * 1000` — the display/sort key (FNP-918).
     *
     * Derived in useSetupIntents rather than returned by the API, so it is
     * optional: a record read straight from the service has not been through
     * that normalisation.
     */
    createdAtMillis?: number
}

export interface ISetupIntentTableColumn extends ITableColumn {
    render?: (item: SetupIntent) => ReactNode;
}

export type ListSetupIntents = {
    listSetupIntents: { items: SetupIntent[], nextToken?: string }
}

export type GetSetupIntent = {
    getSetupIntent: SetupIntent
}

export type CreateSetupIntent = {
    createSetupIntent: SetupIntent
}

export type UpdateSetupIntent = {
    updateSetupIntent: SetupIntent
}

export type DeleteSetupIntent = {
    deleteSetupIntent: string
}
